export default "__VITE_ASSET__4N1m9HUM__"